import { formatHtml } from "@trumpf/ux.common-storybook";
import { exampleSlots, Template } from "./comparison-table.templates";

export default {
    title: "Components/Comparison Table",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-comparison-table",
    argTypes: {
        _slot: { table: { disable: true } },
        exampleSlot: {
            control: {
                type: "select",
            },
            options: Object.keys(exampleSlots),
        },
    },
    args: {
        fullWidth: true,
    },
};

export const ContentTable = {
    args: {
        exampleSlot: Object.keys(exampleSlots)[0],
        variant: "content",
    },
};

export const ContentTableStickyHeaders = {
    args: {
        exampleSlot: Object.keys(exampleSlots)[0],
        variant: "content",
        stickyHeader: true,
        stickyRowHeader: true,
    },
};

export const DataTable = {
    args: {
        exampleSlot: Object.keys(exampleSlots)[1],
        variant: "data",
    },
};

export const DataTableStickyHeaders = {
    args: {
        exampleSlot: Object.keys(exampleSlots)[1],
        variant: "data",
        stickyHeader: true,
        stickyRowHeader: true,
    },
};
